/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrescriptionRequestDto
 */
export interface CreatePrescriptionRequestDto {
    /**
     * Patient ID (Firebase UID)
     * @type {string}
     * @memberof CreatePrescriptionRequestDto
     */
    patientId: string;
    /**
     * Price
     * @type {string}
     * @memberof CreatePrescriptionRequestDto
     */
    price: string;
    /**
     * Status
     * @type {string}
     * @memberof CreatePrescriptionRequestDto
     */
    status?: string;
}

/**
 * Check if a given object implements the CreatePrescriptionRequestDto interface.
 */
export function instanceOfCreatePrescriptionRequestDto(value: object): value is CreatePrescriptionRequestDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function CreatePrescriptionRequestDtoFromJSON(json: any): CreatePrescriptionRequestDto {
    return CreatePrescriptionRequestDtoFromJSONTyped(json, false);
}

export function CreatePrescriptionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrescriptionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'price': json['price'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function CreatePrescriptionRequestDtoToJSON(json: any): CreatePrescriptionRequestDto {
    return CreatePrescriptionRequestDtoToJSONTyped(json, false);
}

export function CreatePrescriptionRequestDtoToJSONTyped(value?: CreatePrescriptionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'price': value['price'],
        'status': value['status'],
    };
}

